import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../openapi';

@Pipe({
  name: 'graveNumberLabel',
  standalone: true
})
export class GraveNumberLabelPipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (application?.service?.url) {
      case '/wniosek-o-dzierzawe-miejsca-grzebalnego': {
        return 'Numer miejsca';
      }
      default: {
        return 'Numer grobu';
      }
    }
  }

}
